export default __webpack_public_path__ + "static/media/team2.c410797f.png";